import api from './api'

export default {
  countStatus() {
    return api.get('/clinical-cares/count-status')
  },
  list(data = {}) {
    const { status, ...params } = data
    return api.get(`/clinical-cares/${status}/list`, { params })
  },
  show(id) {
    return api.get(`/clinical-cares/${id}`)
  },
}
